import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export const Gallery = ({ images, cabinKey }) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);

  const openAt = (i) => {
    setActive(i);
    setOpen(true);
  };

  return (
    <>
      <div
        data-testid={`gallery-${cabinKey}`}
        className="grid grid-cols-2 md:grid-cols-4 gap-3"
      >
        {images.map((src, i) => (
          <button
            key={src}
            data-testid={`gallery-${cabinKey}-img-${i}`}
            onClick={() => openAt(i)}
            className={`relative overflow-hidden rounded-xl group ${
              i === 0 ? "col-span-2 row-span-2 md:col-span-2 md:row-span-2" : ""
            }`}
            style={{ aspectRatio: i === 0 ? "1 / 1" : "1 / 1" }}
          >
            <img
              src={src}
              alt={`${cabinKey} ${i + 1}`}
              loading="lazy"
              className="w-full h-full object-cover transition duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-black/5 group-hover:ring-[#8a6a3f]/30 transition" />
          </button>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid="gallery-lightbox"
          className="max-w-5xl bg-[#4a3520] border-[#8a6a3f]/30 p-0 overflow-hidden"
        >
          <div className="relative aspect-[16/10] bg-black">
            <img
              src={images[active]}
              alt={`${cabinKey} large`}
              className="w-full h-full object-contain"
            />
          </div>
          <div className="flex gap-2 p-3 overflow-x-auto bg-[#3d2a1b]">
            {images.map((src, i) => (
              <button
                key={src}
                onClick={() => setActive(i)}
                className={`shrink-0 w-20 h-14 rounded overflow-hidden ring-2 ${
                  active === i
                    ? "ring-[#e8c875]"
                    : "ring-transparent opacity-70 hover:opacity-100"
                }`}
              >
                <img src={src} alt="" className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
